import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { Button, Container, Row, Col, Spinner, Modal, Table } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import ReactPaginate from "react-paginate";

const BulkMembership = () => {
     const userCity = localStorage.getItem("city_name");
     const mobileNO = localStorage.getItem("mobile");
     const userRole = localStorage.getItem("role"); 
    //  console.log("userole",userRole)


    const [show, setShow] = useState(false);
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);

    const [members, setMembers] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [loadingTable, setLoadingTable] = useState(false);

    const handleShow = () => {
        setFile(null);
        setShow(true);
    };
    const handleClose = () => {
        setShow(false);
        setFile(null);
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const fetchMembers = async (currentPage = 1) => {
        setLoadingTable(true);
        try {
            const cleanCity = userCity && userCity !== "undefined" && userCity !== null ? userCity : "";
            
            const isCoordinator = userRole && userRole.toUpperCase() === "COORDINATOR"; 
            console.log("iscoordinator",isCoordinator)
            
            const mobileToSend = isCoordinator ? mobileNO : "";

            const payload = {
                searchTitle: "",
                documentsPerPage: 10,
                page: currentPage,
                yin_id: "",
                mobile: mobileToSend || "", 
                city :  ""
            };
            
            const response = await axios.post(
                `${process.env.REACT_APP_APIURL}/subscription/getAllPGN`,
                payload
            );

            setMembers(response.data.data || []);
            setTotalPages(response.data.noOfPages || 0);
            setPage(currentPage);

        } catch (error) {
            console.error("Fetch Members Error:", error);
            alert("Failed to fetch members");
        } finally {
            setLoadingTable(false);
        }
    };

    const handlePageChange = (selectedObject) => {
        fetchMembers(selectedObject.selected + 1);
    };

    const handleUpload = async () => {
        if (!file) {
            alert("⚠️ Please select an Excel file!");
            return;
        }

        setLoading(true);
        const formData = new FormData();
        formData.append("file", file);

        try {
            await axios.post(
                `${process.env.REACT_APP_APIURL}/subscription/uploadBulkSubscription`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            alert("File uploaded successfully!");
            handleClose();

            fetchMembers(page);
        } catch (error) {
            console.error("Upload Error:", error);
            alert("Upload failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMembers(1);
    }, [userRole]); 

    return (
        <div>
            <Sidebar />
            <div className="main">
                <div className="topbar">
                    <Navbar title="Bulk Membership Upload" />
                </div>

                <Container fluid className="mt-4">
                    <Row className="justify-content-end me-3">
                        <Col md="auto">
                            <Button
                                onClick={handleShow}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    backgroundColor: "#003147",
                                    color: "white",
                                    border: "none",
                                }}
                            >
                                <Icon.CloudUpload size={18} className="me-2" />
                                Bulk Upload
                            </Button>
                        </Col>
                    </Row>

                    <Row className="mt-4">
                        <Col>
                            {loadingTable ? (
                                <Spinner animation="border" />
                            ) : (
                                <div className="overflow-auto">
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Sr. No</th>
                                                <th>User Name</th>
                                                <th>User Mobile</th>
                                                <th>Coordinator Name</th>
                                                <th>Coordinator Mobile</th>
                                                <th>Bag</th>
                                                <th>Bottle</th>
                                                <th>Kit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {members.length > 0 ? (
                                                members.map((member, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1 + (page - 1) * 10}</td>
                                                        <td>{member.fullName ?? "-"}</td>
                                                        <td>{member.mobile ?? "-"}</td>
                                                        <td>{member.coordinatorName ?? "-"}</td>
                                                        <td>{member.coordinatorMobile ?? "-"}</td>
                                                        <td>{member.claimedRewards?.bag ? "Yes" : "No"}</td>
                                                        <td>{member.claimedRewards?.bottle ? "Yes" : "No"}</td>
                                                        <td>{member.claimedRewards?.kit ? "Yes" : "No"}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center"> 
                                                        No data found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>

                                    {totalPages > 1 && (
                                        <div className="d-flex justify-content-center mt-3">
                                            <ReactPaginate
                                                nextLabel="Next"
                                                previousLabel="Previous"
                                                pageCount={totalPages}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={5}
                                                containerClassName="pagination"
                                                activeClassName="btn btn-primary"
                                                pageClassName="btn"
                                                previousClassName="btn"
                                                nextClassName="btn"
                                                onPageChange={handlePageChange}
                                                forcePage={page - 1}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </Col>
                    </Row>
                </Container>

                <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <Icon.FileEarmarkSpreadsheet className="me-2 text-success" />
                            Upload Excel Data
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="text-center">
                        <div className="d-flex justify-content-end mb-3">
                            <Button
                                variant="light"
                                className="mb-4"
                                style={{
                                    backgroundColor: "#003147",
                                    color: "white",
                                    fontWeight: "500",
                                    border: "none",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "8px",
                                    width: "50%",
                                    padding: "10px",
                                    borderRadius: "8px",
                                }}
                                onClick={() => {
                                    const link = document.createElement("a");
                                    link.href = "/sample_files/sampleFile.xlsx";
                                    link.download = "sampleFile.xlsx";
                                    link.click();
                                }}
                            >
                                <Icon.CloudDownloadFill size={18} />
                                Download Sample File
                            </Button>
                        </div>

                        <input
                            type="file"
                            accept=".xlsx"
                            id="excelFile"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                        />

                        <Button
                            onClick={() => document.getElementById("excelFile").click()}
                            className="mb-3 upload-box"
                            style={{
                                border: "2px dashed #ccc",
                                width: "100%",
                                padding: "12px",
                                backgroundColor: "#fff",
                                color: "#333",
                                cursor: "pointer",
                                transition: "all 0.2s ease-in-out",
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f7f7f7")}
                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
                        >
                            {file ? (
                                <>
                                    <Icon.FileEarmarkExcelFill className="me-2 text-success" />
                                    {file.name}
                                </>
                            ) : (
                                <>
                                    <Icon.Upload className="me-2 text-secondary" />
                                    Insert Excel File
                                </>
                            )}
                        </Button>

                        <Button
                            variant="success"
                            onClick={handleUpload}
                            disabled={loading}
                            style={{ width: "100%" }}
                        >
                            {loading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                    />
                                    Uploading...
                                </>
                            ) : (
                                <>
                                    <Icon.CloudArrowUpFill className="me-2" />
                                    Upload
                                </>
                            )}
                        </Button>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
};

export default BulkMembership;